module.exports = __webpack_public_path__ + "img/left_pic@2x.3eeb8b20.png";